//import { configureStore } from '@reduxjs/toolkit';
import counterReducer from "../features/counter/counterSlice";
import favouriteReducer from "../store/reducers/favourite";
import searchReducer from "../store/reducers/search";
import subscripionReducer from "../store/reducers/subscripion";
import runtimeDetailsReducer from "../store/reducers/runtimeDetails";
import { combineReducers } from "@reduxjs/toolkit";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import enhancedSearchSlice from "../features/enhancedSearch/enhancedSearchSlice";
import searchMetadataSlice from "../features/enhancedSearch/searchMetadataSlice";
import drugSearchSlice from "../features/enhancedSearch/drugSearchSlice";
import findInPageReducer from "../features/findInPage/FindInPageSlice";
import tableOfContentsReducer from "../features/tableOfContents/TableOfContentsSlice";
import networkStatusReducer from "../features/networkStatus/networkStatusSlice";
import toastReducer from "../features/toast/toastSlice";
import openInModalReducer from "../features/openInModal/OpenInModalSlice";
import shareModalReducer from "../features/shareModal/ShareModalSlice";
import fontSizeAdjustorReducer from "../features/fontSizeAdjustor/FontSizeAdjustorSlice";
import contentReducer from "../components/Content/ContentSlice";
import contentSideBarReducer from "../features/topic/ContentSideBarSlice";
import institutionLoginReducer from "../features/login/institutionLoginSlice";

const createRootReducer = () =>
  combineReducers({
    counter: counterReducer,
    favourite: favouriteReducer,
    search: searchReducer,
    subscripion: subscripionReducer,
    runtimeDetails: runtimeDetailsReducer,
    enhancedSearchSlice: enhancedSearchSlice,
    drugSearchSlice: drugSearchSlice,
    searchMetadataSlice: searchMetadataSlice,
    findInPage: findInPageReducer,
    tableOfContents: tableOfContentsReducer,
    networkStatus: networkStatusReducer,
    toast: toastReducer,
    openInModal: openInModalReducer,
    shareModal: shareModalReducer,
    content: contentReducer,
    fontSizeAdjustor: fontSizeAdjustorReducer,
    contentSideBar: contentSideBarReducer,
    institutionLogin: institutionLoginReducer,
  });

export const store = function configureStore(preloadedState) {
  // The below code is commented out to prevent dependency on Redux dev tools in Production
  // const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    createRootReducer(),
    preloadedState,
    composeEnhancers(applyMiddleware(thunk)),
  );
  return store;
};
